<template>
    <modal @close="clearSelectedExtra" dialog="modal-lg" class="dark-top" :footer="false">
        <div slot="title">
            <h2>Service details</h2>
            <h3 v-if="getSelectedExtra">{{ getSelectedExtra.name }}</h3>
        </div>

        <div slot="body">
            <tabs>
                <!-- <tab name="Overview">
                    <overview></overview>
                </tab> -->
                <tab name="Details">
                    <extra-edit></extra-edit>
                </tab>
            </tabs>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    import Overview from '@/components/inventory/extras/ExtraOverview'
    import ExtraEdit from '@/components/inventory/extras/ExtraEdit'

    export default {
        methods: {
            ...mapActions([
                'clearSelectedExtra'
            ]),
        },
        computed: {
            ...mapGetters([
                'getSelectedExtra',
            ])
        },
        components: {
            Modal,
            ExtraEdit,
            Overview,
        }
    }
</script>



// WEBPACK FOOTER //
// ExtraView.vue?403b47f6